import React, { useEffect, useRef, useState } from 'react'
import * as styles from './table.module.scss'
import translate from '../../../helpers/Translate'

export const TableOfContents = ({ roundupProducts, isSingleProduct, singleProductReview, randomHeadings, isRoundUp, scrollDir, scrollPosition, category, howTestedText }) => {

    // console.log( scrollPosition )

    const [ hiddenContent, setHiddenContent ] = useState( false )

    const [ isFixed, setIsFixed ] = useState( false )

    const tableRef = useRef( null ) 

    const tableItemsRef = useRef( null )

    const tableOfContentsRef = useRef( null )

    let content = []

    let tmp = []

    if ( ! isSingleProduct ) {

        let content = null

        if ( howTestedText ) {
            content = JSON.parse( howTestedText )
        } 

        tmp.push({ title : content !== null ? content.title : translate('How we test'), id : 'information_1' })

        tmp.push({ title : translate('Reviews:'), id : ``, notClickable : true})
        
        roundupProducts?.products?.forEach((item, id) => {
            tmp.push({ 
                title :  id + 1 + '. ' + item.shouldBuyTitle, 
                id : item?.shouldBuyTitle?.replaceAll(' ', '_'),
                isSubitem : true,
            })
        })

        // tmp.push({ title : translate(`Comparison of the ${roundupProducts?.products?.length} best ${roundupProducts.dynamicLabel2}`, roundupProducts?.products?.length, roundupProducts.dynamicLabel2), id : 'compareTable' })
        tmp.push({ title : translate(`Comparison`), id : 'compareTable' })
    
    
        roundupProducts?.extraSectionProductRecommendation !== null && roundupProducts?.extraSectionProductRecommendation.forEach((item, id) => {
            tmp.push({ title : `${item.title}`, id : `extra_${id}`})
        })  
    
        roundupProducts?.extraSectionInformationalContent !== null && roundupProducts?.extraSectionInformationalContent.forEach((item, id) => {
            tmp.push({ title : `${item.title}`, id : `e_information_${id}`})
        })  
    
        
    }

    if ( isSingleProduct ) {

        const displayCustomHeadings = category === 'lubes' ? true : false

        const infoContent = [
            { title : randomHeadings.designHeading !== null && displayCustomHeadings && randomHeadings.designHeading !== '' ? randomHeadings.designHeading : translate('Design'), content : singleProductReview?.design, id : 'design' },
            { title : randomHeadings.easyOfUseHeading !== null && displayCustomHeadings && randomHeadings.easyOfUseHeading !== '' ? randomHeadings.easyOfUseHeading : translate('Ease of Use'), content : singleProductReview?.easeOfUse, id : 'easeOfUse' },
            { title : randomHeadings.qualityHeading !== null && displayCustomHeadings && randomHeadings.qualityHeading !== '' ? randomHeadings.qualityHeading : translate('Quality'), content : singleProductReview?.quality, id : 'quality' },
            { title : randomHeadings.priceHeading !== null && displayCustomHeadings && randomHeadings.priceHeading !== '' ? randomHeadings.priceHeading: translate('Price'), content : singleProductReview?.price, id : 'price' },
            { title : randomHeadings.performanceHeading !== null && displayCustomHeadings && randomHeadings.performanceHeading !== '' ?  randomHeadings.performanceHeading : translate('Performance'), content : singleProductReview?.performance, id : 'performance' },
            { title : randomHeadings.packagingHeading !== null && displayCustomHeadings && randomHeadings.packagingHeading !== '' ?  randomHeadings.packagingHeading : translate('Packaging'), content : singleProductReview?.packaging, id : 'packeging' },
            { title : randomHeadings.materialAndCareHeading !== null && displayCustomHeadings && randomHeadings.materialAndCareHeading !== '' ? randomHeadings.materialAndCareHeading : translate('Materials and care'), content : singleProductReview?.materialsAndCare, id : 'materialsAdnCare' },
            { title : translate('Special feature'), content : singleProductReview?.specialFeature, id : 'specialFeature' } 
        ]

        tmp.push({ title : translate('My Verdict'), id : 'a_verdict' })

        tmp.push({ title : translate(`About The ${singleProductReview.dynamicLabel1}`, singleProductReview.dynamicLabel1), id : 'about_sp' })

        tmp.push({ title : randomHeadings.personalExperienceHeading !== null && displayCustomHeadings && randomHeadings.personalExperienceHeading !== '' ? randomHeadings.personalExperienceHeading : 
            // translate(`My Experience With ${singleProductReview.dynamicLabel1}`, singleProductReview.dynamicLabel1), id : 'personalExperience' }
            translate(`Personal Experience`), id : 'personalExperience' }
        )

        infoContent.forEach( item => {
            item.content !== null &&  tmp.push({ title : item.title, id : item.id })
        })

        tmp.push({ title : translate(`Specifications and features`), id : 'specifications' })

        tmp.push({ title : translate(`Comparing ${singleProductReview?.dynamicLabel1} with alternatives`, singleProductReview?.dynamicLabel1), id : 'compareTable' })
       
       
    }

    content = tmp   

    const handleScroll = ( item ) => {

        setHiddenContent( hiddenContent ? false : true )

        const violation = document.getElementById( item.id )

        const timeout = window.innerWidth > 500 ? 200 : 500

        setTimeout(() => {

            const scrollPosition = isSingleProduct ? violation.offsetTop - 130 : violation.offsetTop - 70

            window.scrollTo({

                top: scrollPosition,
    
                behavior : 'smooth'
    
            })

        }, timeout )

    }

    const handleHiddenContent = () => {

        setHiddenContent( hiddenContent ? false : true )

        !hiddenContent && executeScroll()
        
    }

    const executeScroll = () => tableRef.current.scrollIntoView()

    useEffect(() => {
        
        const onScroll = () => {

            if ( window.innerWidth > 500 ) {
                
                const top = tableItemsRef.current !== null && tableItemsRef.current.getBoundingClientRect().top

                top < -560 && setHiddenContent( false )
                top > 600 && setHiddenContent( false )

            }
        
        }
      
        window.removeEventListener('scroll', onScroll)

        window.addEventListener('scroll', onScroll, { passive: true })

        return () => window.removeEventListener('scroll', onScroll)

    }, [])

    useEffect(() => {

        let triggerSection 
        if ( document.getElementById('information_1') ) {
            triggerSection = document.getElementById('information_1')
        } else if ( document.getElementById('a_verdict') ) {
            triggerSection = document.getElementById('a_verdict')
        }

        const header = document.getElementById('mainHeader')

        if ( triggerSection ) {
            if ( scrollDir === 'up' ) {
                if ( triggerSection.getBoundingClientRect().top < 0  ) {
                    setIsFixed( true )
                    header.style.boxShadow = 'none'
                } else {
                    setIsFixed( false )
                    header.style.boxShadow = ''
                    setHiddenContent( false )
                }
            } else {
                setIsFixed( false )
                header.style.boxShadow = ''
                setHiddenContent( false )
            }
        }   

    }, [ scrollDir, scrollPosition?.top ])

    useEffect(() => {

        const handleClickOutside = (event) => {
          if (tableOfContentsRef.current && !tableOfContentsRef.current.contains(event.target)) {
            setHiddenContent( false )
          }
        }

        document.addEventListener('click', handleClickOutside, true)

        return () => {
          document.removeEventListener('click', handleClickOutside, true)
        }

    }, [])


    useEffect(() => {

        const windowHeight = window.innerHeight

        const tableOfContentsHeight = tableItemsRef.current.getBoundingClientRect().height

        const tableOfContentsTop = tableOfContentsRef.current.getBoundingClientRect().top

        if ( tableOfContentsHeight > windowHeight - tableOfContentsTop ) {
            // tableItemsRef.current.style.maxHeight = windowHeight - tableOfContentsTop - 50 + 'px'
            tableItemsRef.current.style.maxHeight = windowHeight - tableOfContentsTop - 110 + 'px'
            tableItemsRef.current.style.overflowY = 'auto'
        }    
        
    }, [ hiddenContent ])

    return(
        <>
        <section className={`${styles.tableOfContents} ${isFixed ? styles.fixed : ''}`} ref={tableOfContentsRef}>
            <div className={`wrapper-roundup ${styles.tableOfContents__wrapper}`} >
                <div className={styles.input} style={{ paddingRight : '0', width : '100%' }}>
                    <div className={styles.customSelect} ref={tableRef}>
                        <div 
                            
                            className={styles.customSelect__control} 
                            onClick={handleHiddenContent}>
                            <p>{translate('Table of contents')} ({content.length})</p>
                            <svg 
                                width="20" 
                                height="12" 
                                viewBox="0 0 20 12" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ transform : hiddenContent ? 'rotate(180deg)' : ''}}>
                                <path d="M1.15039 1.97559L9.64463 10.4696L18.1387 1.97559" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <nav className={`${styles.hiddenContent} ${hiddenContent ? styles.show_hidden : ''}`} ref={tableItemsRef}>
                            <ul>
                                {content.map((item, id) => 
                                    <li  key={`cont-${id}`}>
                                        <a
                                        href={`#${item.id}` } 
                                        className={`${styles.hiddenContent__item} ${! item.isSubitem  ? '' : styles.subitem} ${item.notClickable ? styles.no_hover : ''}`} 
                                        style={{ textTransform : !isSingleProduct && id === 0 ? 'capitalize' : '' }}
                                        onClick={() => (! item.notClickable && handleScroll( item ))} 
                                        title={item.title}
                                        >
                                            {item.title}
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}